var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoLectura(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_23758",
    "data-name": "Grupo 23758",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.453,
    height: 9.943,
    viewBox: "0 0 18.453 9.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15522",
    "data-name": "Trazado 15522",
    d: "M14.933,9.943a.619.619,0,0,1-.44-.183L12.625,7.892l1.907-1.908.4.4,6.2-6.2A.612.612,0,0,1,21.575,0a.618.618,0,0,1,.44.183l1.026,1.026a.625.625,0,0,1,0,.881L15.371,9.76A.611.611,0,0,1,14.933,9.943Z",
    transform: "translate(-4.768 0)",
    fill: "#c2c2c2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-double",
    "data-name": "Icon awesome-check-double",
    d: "M13.077,6.964,12.052,5.939a.619.619,0,0,0-.878,0l-6.2,6.2L2.085,9.254a.619.619,0,0,0-.878,0L.179,10.282a.622.622,0,0,0,0,.881L4.53,15.516a.619.619,0,0,0,.878,0l7.666-7.672A.625.625,0,0,0,13.077,6.964Z",
    transform: "translate(0.004 -5.756)",
    fill: "#c2c2c2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoLectura);
export default __webpack_public_path__ + "static/media/icono-lectura.19aab1897f1590e5b6ae56741960ac25.svg";
export { ForwardRef as ReactComponent };